import { logger } from '../../../../utils/common/logger'
import { DOMUtils } from '../../../../utils/dom'
import { Store } from '../../../../utils/storage/keys'
import { IdentityEvent } from '../../../common/events/identity'
import { IdentityScreen } from '../../enums'
import { LoginService } from '../loginradius/services/login-service'
import { IdentityFormAPI } from './form-api'
import { IdentityFormUtils } from './form-utils'

export class ForgotPasswordForm {
    private static DOM = {
        form: 'forgotPasswordForm'
    }
    private submissionEventName = 'forgot-password'

    /**
     * Listens for the form validated event in the Forgot Password form
     */
    public init() {
        logger('debug', 'Initializing Forgot Password form')
        const form = this.getFormElement()

        if (form) {
            document.addEventListener(IdentityEvent.FORM_VALIDATED, async (event: CustomEvent) => {
                const formType = event.detail.form
                if (formType === ForgotPasswordForm.DOM.form) {
                    await this.submitForm(form)
                }
            })
             // show the form
            DOMUtils.addClass(document.body, 'identity-screen-form--active')
        }
        logger('debug', 'Forgot Password form initialized')
    }

    /**
     * Calls Forgot Password LR API endpoint
     */
    public async submitForm(form: HTMLFormElement) {
        const formData = new FormData(form)
        // The dataObj creation below might be simplified with the Object.fromEntries but our current
        // ts config doesn't recognize it.
        const dataObj: Record<string, unknown> & {csrfmiddlewaretoken: string} = {csrfmiddlewaretoken: undefined}
        formData.forEach((value, key) => dataObj[key] = value)
        const redirect = LoginService.buildRedirectUrl(location.origin)
        const searchParams = new URLSearchParams()
        searchParams.append('redirect', redirect)
        if (sessionStorage) {
            if (redirect.includes('/home-delivery/')) {
                searchParams.append(
                    Store.CAMPAIGN, sessionStorage.getItem(Store.CAMPAIGN)
                )
                searchParams.append(
                    Store.CAMPAIGN_NAME, sessionStorage.getItem(Store.CAMPAIGN_NAME)
                )
                searchParams.append(
                    Store.OFFER_GROUP, sessionStorage.getItem(Store.OFFER_GROUP)
                )
            }
            // Checkout modal logic
            // If pianoParams are available then we need to pass them to ensure
            // that the checkout modal is shown on the final page.
            const pianoParams = LoginService.getPianoParams()
            if (pianoParams) {
                searchParams.append(
                    Store.PIANO_PARAMS, pianoParams
                )
            }
        }

        dataObj.query = searchParams.toString()

        try {
            await IdentityFormAPI.sendResetPasswordEmail(dataObj)
            return this.onSuccess()
        } catch (error) {
            const errors = IdentityFormUtils.structureErrors(error)
            return this.onError(errors)
        }
    }

    /**
     * Success callback function
     */
    protected onSuccess() {
        LoginService.sendFormSubmissionEvent(this.submissionEventName)
        // hide form and show success message
        DOMUtils.removeClass(document.body, IdentityScreen.FORM)
        DOMUtils.addClass(document.body, IdentityScreen.SUCCESS)
    }

    /**
     * Error callback function
     * @param errors any
     *
     */
    protected onError(errors: any) {
        logger('error', errors)
        LoginService.sendSubmissionErrorAnalytics(errors, this.submissionEventName)
        LoginService.clearErrors()
        LoginService.showErrors(errors)
    }

    /**
     * Get HTMLFormElement representation of the Email Verification form
     */
    private getFormElement(): HTMLFormElement | undefined {
        return document.querySelector(`[data-id-form=${ForgotPasswordForm.DOM.form}]`)
    }
}
